// extracted by mini-css-extract-plugin
export default {"wrapper":"data-medium-block_wrapper__v0BBZ"};